import React, { useState, useEffect } from "react";
import { authActions } from "../../store/actions/auth.actions";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import LoginPageStyle from "../../styles/LoginPageStyle";
import LoginBanner from "../../components/loginBanner";
import MessagePanel from "../../components/messagePanel";
import { validatePassword } from "../../helpers/validate.helper";
import { AccountActionsState } from "../../store/types/auth";
import { IDRaksStore } from "../../store/store";

interface ResetHaslaProps {
  error: string;
  accountActionsState: AccountActionsState;
  onResetPassword: Function;
  onClearError: Function;
  onClearAccountActionsState: Function;
  match: any;
}

export const ResetHaslaPage = (props: ResetHaslaProps) => {
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [repasswordError, setRepasswordError] = useState("");
  const { onClearError, onClearAccountActionsState, match } = props;

  useEffect(() => {
    return () => {
      onClearError();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    onClearAccountActionsState();
    // eslint-disable-next-line
  }, []);

  function handleSubmit(e: React.FormEvent<HTMLElement>) {
    e.preventDefault();
    onClearError();
    const errPassword = validatePassword(password);
    const errRePassword = !repassword ? "Pole wymagane" : "";
    setPasswordError(errPassword);
    setRepasswordError(errRePassword);
    if (password && repassword) {
      if (password !== repassword)
        setRepasswordError("Hasło i powtórzone hasło nie zgadzają się");
      else if (!errPassword && !errRePassword)
        props.onResetPassword(match.params.email, match.params.token, password);
    }
  }

  const useStyles = makeStyles({
    input: {
      fontFamily: "text-security-disc",
    },
  });

  const classes = useStyles();

  return (
    <>
      <LoginPageStyle>
        <div className="loginContainer">
          <div className="loginContainer__error">
            {props.error && (
              <MessagePanel title="Błąd!" mode="error" message={props.error} />
            )}
          </div>

          {props.accountActionsState ===
          AccountActionsState.ResetPswdSuccess ? (
            <div className="loginContainer__info">
              <div className="loginContainer__info__primarytext">
                <h5 className="light">Hasło dla konta</h5>
                <h5 className="light">{match.params.email}</h5>
                <h5 className="light">zostało zmienione.</h5>
              </div>
              <div className="loginContainer__info__primarytext">
                <div className="light subtitle1">
                  Przejdź teraz na ekran logowania
                </div>
                <div className="light subtitle1">i zaloguj się do programu</div>
                <div className="light subtitle1">z użyciem nowego hasła.</div>
              </div>
              <Link to="/login" className="loginContainer__info__button">
                <Button variant="contained" color="secondary">
                  ZALOGUJ SIĘ
                </Button>
              </Link>
            </div>
          ) : (
            <div className="loginContainer__main">
              <div className="loginContainer__main__window">
                <div className="loginContainer__main__window__header">
                  <h4>Podaj nowe hasło</h4>
                  <div className="loginContainer__main__window__subheader">
                    <span className="disabled subheader2">dla konta </span>
                    <span className="high subheader2">
                      {match.params.email}
                    </span>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <FormControl
                    error={passwordError !== ""}
                    className="signUpPassword"
                  >
                    <TextField
                      helperText={
                        "Użyj co najmniej 8 znaków, zastosuj małe i duże litery oraz cyfry."
                      }
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      label="Nowe hasło"
                      InputProps={{ classes: { input: classes.input } }}
                    />
                    {passwordError && (
                      <FormHelperText id="password-error-text">
                        {passwordError}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl error={repasswordError !== ""}>
                    <TextField
                      value={repassword}
                      onChange={(e) => setRepassword(e.target.value)}
                      label="Powtórzone nowe hasło"
                      InputProps={{ classes: { input: classes.input } }}
                    />
                    {repasswordError && (
                      <FormHelperText id="repassword-error-text">
                        {repasswordError}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <div className="loginContainer__main__window_signupbutton">
                    <Button type="submit" variant="contained" color="secondary">
                      ZAPISZ
                    </Button>
                  </div>
                </form>
              </div>
              <div className="loginContainer__main__additionaloption medium subtitle2">
                Wróć na ekran{" "}
                <Link to="/login" className="link">
                  logowania
                </Link>
              </div>
            </div>
          )}

          <div className="medium subtitle1 loginContainer__footer"></div>
        </div>
        <LoginBanner />
      </LoginPageStyle>
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error,
    accountActionsState: store.auth.accountActionsState,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onResetPassword: (email: string, token: string, password: string) =>
      dispatch(authActions.resetPassword(email, token, password)),
    onClearAccountActionsState: () => {
      dispatch(authActions.clearAccountActionsState());
    },
    onClearError: () => {
      dispatch(authActions.clearError());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetHaslaPage);
